import React from 'react'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export const CustomSelect = ({ currentItem, handleItemChange, allItems, variant = 'default' }) => {
  const { t } = useTranslation()

  const styles = variant === 'dark'
    ? {
        width: 220,
        height: 50,
        backgroundColor: 'rgba(52, 148, 182, 0.3)',
        borderRadius: '12px',
        color: 'white',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.25)'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.4)'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.5)'
        },
        '& .MuiSelect-icon': {
          color: 'white'
        },
        '& .MuiSelect-select': {
          color: 'white'
        }
      }
    : {
        width: 220,
        height: 50,
        backgroundColor: 'white',
        borderRadius: '12px',
        color: '#333',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.15)'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(52, 148, 182, 0.5)'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#3494b6'
        },
        '& .MuiSelect-icon': {
          color: '#3494b6'
        },
        '& .MuiSelect-select': {
          color: '#333'
        }
      }

  return (
    <Select
      value={currentItem}
      onChange={handleItemChange}
      sx={styles}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            '& .MuiMenuItem-root': {
              color: '#333',
              '&:hover': {
                backgroundColor: 'rgba(52, 148, 182, 0.08)'
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(52, 148, 182, 0.15)',
                '&:hover': {
                  backgroundColor: 'rgba(52, 148, 182, 0.2)'
                }
              }
            }
          }
        }
      }}
    >
      {Object.keys(allItems).map((item, i) => {
        return (
          <MenuItem style={{ fontSize: 14 }} key={i} value={item}>
            {t(allItems[item])}
          </MenuItem>
        )
      })}
    </Select>
  )
}

CustomSelect.propTypes = {
  currentItem: PropTypes.string,
  handleItemChange: PropTypes.func,
  allItems: PropTypes.object
}
